import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Initialize fbq function
    if (window.fbq) return; // Already loaded
    const fbq: any = function () {
      fbq.callMethod ? fbq.callMethod.apply(fbq, arguments) : fbq.queue.push(arguments);
    };
    if (!window._fbq) window._fbq = fbq;
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = '2.0';
    fbq.queue = [];
    window.fbq = fbq;
    // Create and inject script tag
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    // Append to document head
    document.head.appendChild(script);
    // Initialize pixel after script loads
    script.onload = () => {
      window.fbq('init', '2701648143532370');
      window.fbq('track', 'PageView');
    };
    // Fallback if script is already loaded
    if (script.readyState === 'complete') {
      window.fbq('init', '2701648143532370');
      window.fbq('track', 'PageView');
    }
  }, []);
  return <noscript data-id="element-168">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=2701648143532370&ev=PageView&noscript=1" alt="" data-id="element-169" />
    </noscript>;
}
// Utility functions for tracking events
export const trackEvent = (eventName: string, data?: object) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', eventName, data);
  }
};
export const trackInitiateCheckout = () => {
  trackEvent('InitiateCheckout', {
    content_name: 'Viridia Instant-Reply Booking System',
    value: 297,
    currency: 'USD'
  });
};
export const trackLead = () => {
  trackEvent('Lead', {
    content_name: 'Strategy Call Booking'
  });
};
export const trackViewContent = () => {
  trackEvent('ViewContent', {
    content_name: 'Pricing Section'
  });
};